import { Box, Card, CardContent, CardHeader, Divider, Grid, Stack, Typography } from '@mui/material';
import Container from '@mui/material/Container';
import { useMemo } from 'react';

import { useConnectedAccounts } from '@/api/userAccount';
import { PageTitle } from '@/components/PageTitle';
import { AvatarSection } from '@/components/userAccount/AvatarSection';
import { ConnectedAccountsSection } from '@/components/userAccount/ConnectedAccountsSection';
import { ContactInfoSection } from '@/components/userAccount/ContactInfoSection';
import { EmailSection } from '@/components/userAccount/EmailSection';
import { PasswordSection } from '@/components/userAccount/PasswordSection';

export const UserAccount = () => {
    const { data: connectedAccounts } = useConnectedAccounts();

    const hasConnectedAccounts = useMemo(() => connectedAccounts?.length, [connectedAccounts]);

    return (
        <>
            <Box component="main" sx={{ flexGrow: 1 }}>
                <Container maxWidth="lg">
                    <PageTitle title="User Account" />
                    <Stack>
                        <Box>
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <AvatarSection />
                                </Grid>
                                <Grid container size={{ xs: 12, md: 8 }}>
                                    <Card>
                                        <CardHeader title={<Typography variant="h4">Profile</Typography>} />
                                        <CardContent sx={{ pt: 0 }}>
                                            <Stack spacing={3} divider={<Divider />}>
                                                <ContactInfoSection />
                                                <EmailSection />
                                                <PasswordSection />
                                                {hasConnectedAccounts && <ConnectedAccountsSection />}
                                            </Stack>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Box>
                    </Stack>
                </Container>
            </Box>
        </>
    );
};
